module.exports = __webpack_public_path__ + "static/media/img-default-marketplace-logo.dd0fae17.png";